export enum Permission {
  Administrator = 'administrator',
  ITAdmin = 'role.it_admin',
  ITManager = 'role.it_manager',
  BusinessAdmin = 'role.business_admin',
  FleetManager = 'role.fleet_manager',
  UserManagement = 'user_management',
  AuditHistory = 'audit_history',

  // CZ
  Dealer = 'role.dealer',
  DeliverySpecialist = 'role.delivery_specialist',
  DeliveryManager = 'role.delivery_manager',
  ClientAccount = 'role.client_account',
  KeyAccountManager = 'role.key_account_manager',
  Backoffice = 'role.backoffice',

  // FI
  Driver = 'role.driver',
  HR = 'role.hr',
  VehicleSupplier = 'role.vehicle_supplier',
  TyreSupplier = 'role.tyre_supplier',
  SupplierSuperUser = 'role.supplier_super_user',
  PurchaseSupport = 'role.purchase_support',
  CustomerCare = 'role.customer_care',
}